import React, { Component } from 'react'
import { ReactComponent as IconIncidentReport } from "../icons/icon-incident-report.svg";
import { Grommet, Box, Text, Tag } from "grommet";
import styled from 'styled-components';
import './index.css'
import { OPS_DATA_URL, INCIDENT_STATUS } from "../config";
import CustomMenuTable from './CustomMenuTable';
import { getLocalUTCTime, getTimeCompare, getTimeDuration } from '../utils/CommonUtil';


const IconMenuCard = (props) => (
  <Box className='reportWin'>
    <Box direction='row' alignContent='start' className='reportLine'>
      <Box align="center" className='iconOuter'>
        <IconIncidentReport className='iconBox'></IconIncidentReport>
      </Box>
      <Box className='reportText' >
        <HighlightText >Incident report</HighlightText>
      </Box>
    </Box>
    <Box alignContent='start' direction='row' height="300px" className='searchTable'>
      <CustomMenuTable data={props.data} columns={props.columns} changeSelectValue={props.changeSelectValue} />
    </Box>
  </Box>
)

const HighlightText = styled(Text)`
  
  font-size: 100%;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.22px;
  text-transform: uppercase;
  color: #333333;
`

const HighlightTitleText = styled(Text)`
  
  height: 24px;
  font-size: 100%;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.22px;
  color: #333333;
`


const CustomTimeCard = (props) => (
  <Box >
    <Box direction="row-responsive">
      <Box direction="row">
        <Box >
          <Box style={{ margin: '6px' }}>
            <TitleText >Start time</TitleText>
          </Box>
          <Box style={{ margin: '6px', width: '260px' }}>
            <BodyText>{props.startTime}</BodyText>
          </Box>
        </Box>

        <Box>
          <Box style={{ margin: '6px' }}>
            <TitleText>End time</TitleText>
          </Box>
          <Box style={{ margin: '6px', width: '260px' }}>
            <BodyText>{props.endTime}</BodyText>
          </Box>
        </Box>
      </Box>
      <Box style={{ width: '90px' }} />
      <Box>
        <Box style={{ margin: '6px' }}>
          <TitleText>Duration</TitleText>
        </Box>
        <Box style={{ margin: '6px', width: '210px' }}>
          <BodyText>{props.duration}</BodyText>
        </Box>
      </Box>
    </Box>
  </Box>
)

const CustomContent = (props) => (
  <Box direction="row-responsive" style={{ marginTop: "10px", marginRight: "10px" }} width="80vm">
    <BodyDescText dangerouslySetInnerHTML={{ __html: props.value }} />
  </Box>
)

const BodyDescText = styled(Text)`
 
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #333333;
  white-space:pre-wrap;
`

const BodyText = styled(Text)`
width: 100%;
height: 16px;
font-size: 16px;
font-weight: normal;
font-style: normal;
font-stretch: normal;
line-height: 1;
letter-spacing: normal;
color: #000000;
`

const TitleText = styled(Text)`
  width: auto;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.16px;
  color: rgba(0, 0, 0, 0.45);
`

export default class IncidentWin extends Component {

  constructor(props) {
    super(props)
    this.state = {
      data: [],
      incidentDetail: [],
      columns: [{
        label: 'Subject',
        name: "subject",
        width: '100px',
        options: {
          sort: false
        }
      }, {
        label: 'id', name: 'id', options: {
          display: false,
          viewColumns: false,
          sort: false
        }
      }, {
        label: 'farm', name: 'farm', options: {
          display: false,
          viewColumns: false,
          sort: false
        }
      }, {
        label: 'start_time',
        name: 'start_time',
        options: {
          display: false,
          sortDirection: 'desc',
          viewColumns: false
        }
      }]
    }
  }

  componentDidMount() {
    this.getIncidentData()
  }

  sortList = (a, b) => {
    return getTimeCompare(b.start_time, a.start_time)
  }

  getIncidentData() {
    let farmCode = this.props.farmCode;
    let url = `${OPS_DATA_URL}`
    fetch(url + `/incidents/list/${farmCode}`).then(res => {
      if (res.ok) {
        res.json().then(data => {
          let lastIncident = (data && data.length > 0) ? data.sort(this.sortList)[0] : {};
          this.setState({
            data: data,
            incidentDetail: lastIncident
          })
          this.props.updateLast(lastIncident);
        })
      }
    })
  }

  changeSelectValue = (indexData, farmCode) => {
    let url = `${OPS_DATA_URL}`
    fetch(url + `/incidents/${indexData}`).then(res => {
      if (res.ok) {
        res.json().then(data => {
          this.setState({
            incidentDetail: data
          })
        })
      }
    })
  }

  render() {
    const { data, columns, incidentDetail } = this.state;
    let subject = incidentDetail.subject ? incidentDetail.subject : 'No incident in the past 90 days';
    let farm = incidentDetail.farm ? incidentDetail.farm : '';
    let start_time = incidentDetail.start_time ? getLocalUTCTime(incidentDetail.start_time) : '';
    let end_time = incidentDetail.end_time ? getLocalUTCTime(incidentDetail.end_time) : '';
    let duration = incidentDetail.end_time ? getTimeDuration(incidentDetail.end_time, incidentDetail.start_time) : '';
    let ci_status = incidentDetail.ci_status ? incidentDetail.ci_status : undefined;
    let current_status_item = INCIDENT_STATUS.find(item => item.label === ci_status);
    let status_color = "gray";
    if (current_status_item) {
      status_color = current_status_item.color;
    }
    return (
      <Grommet>
        <Box justify="evenly" direction="row-responsive" style={{ marginTop: '14.5px' }} >
          <IconMenuCard data={data} columns={columns} changeSelectValue={this.changeSelectValue} />
          <div className='contentWidth'>
            <Box direction="row-responsive" width="757px" height={{ min: "400px" }}>
              <Box align="start" alignContent="start" style={{ marginTop: '10px' }}>
                <Box style={{ marginBottom: '5px' }} fill="horizontal" direction="row-responsive" justify="between">
                  <Box>
                    <TitleText>{start_time}</TitleText>
                  </Box>
                  <Box>
                    {ci_status ?
                      <Tag value={ci_status}
                        size="xsmall"
                        round="large"
                        style={{ color: "#ffffff" }}
                        background={{ color: status_color }} /> : <Box />}
                  </Box>
                </Box>
                <Box direction="row-responsive">
                  <Box width="567px" justify="center">
                    <HighlightTitleText>{farm.toUpperCase()} - {subject.toUpperCase()}</HighlightTitleText>
                  </Box>
                </Box>
                <CustomTimeCard type="Incident" startTime={start_time} endTime={end_time} duration={duration} />
                <CustomContent value={incidentDetail.desc} />

              </Box>
            </Box>
          </div>
        </Box>
      </Grommet>
    )
  }
}

